import request from '@/libs/request'

// 店铺列表
export function shopListApi (data) {
  return request({
    url: `shop/list`,
    method: 'get',
    params: data
  })
}

// 店铺添加/编辑
export function shopSaveApi (data) {
  return request({
    url: `shop/save`,
    method: 'post',
    data: data
  })
}

// 店铺详情
export function shopInfoApi (id) {
  return request({
    url: `shop/detail/${id}`,
    method: 'get'
  })
}

// 修改店铺状态
export function changeShopStatusApi (id) {
  return request({
    url: `shop/changeStatus/${id}`,
    method: 'post'
  })
}

// 店铺删除
export function shopDelApi (id) {
  return request({
    url: `shop/delete/${id}`,
    method: 'delete'
  })
}

// 店铺数据 所有店铺
export function shopAllApi (data = {}) {
  return request({
    url: `shop/all`,
    method: 'get',
    params: data
  })
}

// 审核
export function changeVerify (data = {}) {
  return request({
    url: `shop/changeVerifyStatus`,
    method: 'post',
    data
  })
}


// 根据手机号查询用户
export function searchUserByPhoneApi (phone, shopId = 0) {
  return request({
    url: `shop/searchUserByPhone`,
    method: 'get',
    params: {
      phone: phone,
      shop_id: shopId
    }
  })
}
